import type { Basis, Person, Priority, Status } from './api.ts';

const fmtD = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', timeZone: 'UTC' });
const fmtDY = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
export const fmtDate = (iso: string | null | undefined) => {
  if (!iso) return '';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso);
  return (d.getUTCFullYear() === new Date().getUTCFullYear() ? fmtD : fmtDY).format(d);
};
export const fmtWhen = (iso: string) => new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(new Date(iso));
export const ago = (iso: string) => {
  const s = (Date.now() - Date.parse(iso)) / 1000;
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
export const today = () => new Date().toISOString().slice(0, 10);
export const isOverdue = (t: { end_date: string | null; status: string }) => !!t.end_date && t.end_date < today() && t.status !== 'done' && t.status !== 'cancelled';
export const statusLabel: Record<Status, string> = { planned: 'Planned', active: 'In progress', blocked: 'Blocked', done: 'Done', cancelled: 'Cancelled' };
export const priorityLabel: Record<Priority, string> = { urgent: 'Urgent', high: 'High', medium: 'Medium', low: 'Low' };
// Most pressing first; no priority sorts with medium, so unset tasks are not buried.
export const priorityRank = (p: Priority | null | undefined) => ({ urgent: 0, high: 1, medium: 2, low: 3 })[p ?? 'medium'];
export const basisLabel: Record<Basis, string> = { unknown: 'No date', estimate: 'Estimate', target: 'Target', confirmed: 'Confirmed' };
export const firstName = (email: string | null | undefined, people: Person[] = []) => {
  if (!email) return 'Unassigned';
  if (email === 'operator@agents.gbsoft.dev') return 'Ops';
  const p = people.find((x) => x.email === email);
  return (p?.name || email.split('@')[0]).split(' ')[0];
};
// "Moved by Gemini" flags real changes; a drafted baseline is shown as estimates instead.
export const recentlyByAgent = (t: { last_updated_by_agent: null | { at: string; source?: string } }, days = 7) =>
  !!t.last_updated_by_agent && t.last_updated_by_agent.source !== 'baseline' && Date.now() - Date.parse(t.last_updated_by_agent.at) < days * 86400_000;
